import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateDomainSettingsMutationVariables = Types.Exact<{
  input: Types.DomainSettingsInput;
}>;


export type UpdateDomainSettingsMutation = { __typename?: 'Mutation', updateDomainSettings: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } };


export const UpdateDomainSettingsDocument = gql`
    mutation UpdateDomainSettings($input: DomainSettingsInput!) {
  updateDomainSettings(input: $input) {
    errors {
      location
      context
      type
    }
  }
}
    `;
export type UpdateDomainSettingsMutationFn = Apollo.MutationFunction<UpdateDomainSettingsMutation, UpdateDomainSettingsMutationVariables>;

/**
 * __useUpdateDomainSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateDomainSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDomainSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDomainSettingsMutation, { data, loading, error }] = useUpdateDomainSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDomainSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDomainSettingsMutation, UpdateDomainSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDomainSettingsMutation, UpdateDomainSettingsMutationVariables>(UpdateDomainSettingsDocument, options);
      }
export type UpdateDomainSettingsMutationHookResult = ReturnType<typeof useUpdateDomainSettingsMutation>;
export type UpdateDomainSettingsMutationResult = Apollo.MutationResult<UpdateDomainSettingsMutation>;
export type UpdateDomainSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateDomainSettingsMutation, UpdateDomainSettingsMutationVariables>;